<template>
    <div class="c-panel c-panel--small">

        <template v-if="!enabled">
            <h3 class="margin-b-16">Scan de code</h3>
            <p>Open de app Google Authenticator op je telefoon of tablet en scan de onderstaande QR-Code</p>

            <template v-if="isSVG">
                <p v-html="qrcode"></p>
            </template>
            <template v-else>
                <p><img :src="qrcode"/></p>
            </template>

        </template>
        <template v-else>
            <h3 class="margin-b-16">Voer je verificatiecode in</h3>
        </template>

        <p>Vul hieronder de verificatiecode in die wordt weergeven in de app.</p>

        <c-form ref="form" @valid="submit" :autocomplete="'off'">

            <c-input
                type="text"
                v-model="secret"
                data-pattern="[\d]{6}"
                required
                name="otp_secret"
                autocomplete="off"
                :label="'Verificatiecode'"
                autofocus
            />

            <p class="color-alert" v-if="error">Verificatiecode is niet correct of is verlopen.</p>

            <button class="c-btn c-btn--expanded margin-t-32 no-margin-b" :disabled="processing">Versturen</button>

        </c-form>

    </div>
</template>

<script>
import Form from '@mixins/Form';
import {ValidationError} from '@app/errors';

export default {
    mixins: [Form],
    data() {
        return {
            secret: '',
            enabled: true,
            qrcode: null,
            processing: false,
            error: false
        }
    },
    methods: {
        submit() {

            this.processing = true;
            this.error = false;

            if (this.enabled) {

                this.$xhr.post('/api/auth/google2fa/verify', {otp_secret: this.secret}).then(({result}) => {
                    this.$store.dispatch('user/setAuthorized')
                        .then(() => {
                            this.processing = false;
                            this.$router.push('/')
                        })
                }).catch((e) => {
                    if (e instanceof ValidationError) {
                        this.$refs.form.setErrors(e.errors);
                    }
                    this.processing = false;
                    this.error = true;
                    this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Verificatie mislukt'});
                });
            } else {
                this.$xhr.post('/api/auth/google2fa/enable', {otp_secret: this.secret}).then(() => {
                    this.$store.dispatch('user/setAuthorized')
                        .then(() => {
                            this.$store.dispatch('user/setOtpEnabled')
                                .then(() => {
                                    this.processing = false;
                                    this.$router.push({path: '/tweestapsverificatie/succes'});
                                });
                        })
                }).catch(() => {
                    if (e instanceof ValidationError) {
                        this.$refs.form.setErrors(e.errors);
                    }
                    this.processing = false;
                    this.error = true;
                    this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Verificatie opslaan mislukt'});
                });
            }
        }
    },
    computed: {
        isSVG() {
            return this.qrcode.indexOf('<?xml') === 0;
        }
    },
    created() {

        this.$xhr.get('/api/auth/google2fa/qrcode').then(({result}) => {
            if (result && result.qrcode) {
                this.enabled = false;
                this.qrcode = result.qrcode;
            }
        }).catch((e) => {
            this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'QR-code kan niet worden ingeladen'});
        });
    }

}
</script>
